var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-input',_vm._g(_vm._b({ref:"input",attrs:{"options":_vm.items,"disabled":_vm.disabled}},'edit-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }